import type { ReactNode } from 'react';
import styled from 'styled-components';
import MediaQueryHelper from './MediaQueryHelper';

const FlexCenterDiv = styled.div<{ backgroundColor?: string }>`
  display: flex;
  justify-content: center;
  width: 100%;

  ${({ backgroundColor }) => `
    background-color: ${backgroundColor}
  `}
`;

const MaxWidthLayoutContentDiv = styled.div`
  max-width: 1140px;
  width: 97vw;
  margin-left: 1.5vw;
  margin-right: 1.5vw;
`;

const MobileMaxWidthLayoutContentDiv = styled.div`
  max-width: 400px;
  width: 92vw;
  margin-left: 4vw;
  margin-right: 4vw;
`;

type MaxWidthLayoutProps = { children: ReactNode; backgroundColor?: string };

const MaxWidthLayout = ({
  children,
  backgroundColor,
}: MaxWidthLayoutProps) => {
  const DesktopBody = (
    <FlexCenterDiv backgroundColor={backgroundColor}>
      <MaxWidthLayoutContentDiv>
        { children }
      </MaxWidthLayoutContentDiv>
    </FlexCenterDiv>
  );

  const MobileBody = (
    <FlexCenterDiv backgroundColor={backgroundColor}>
      <MobileMaxWidthLayoutContentDiv>
        { children }
      </MobileMaxWidthLayoutContentDiv>
    </FlexCenterDiv>
  );

  const compToRender = (
    <MediaQueryHelper
      desktopChildren={DesktopBody}
      mobileChildren={MobileBody}
    />
  );

  return compToRender;
};

export const MaxWidthLayoutDesktop = ({ children }: Pick<MaxWidthLayoutProps, 'children'>) => {
  const DesktopBody = (
    <FlexCenterDiv>
      <MaxWidthLayoutContentDiv>
        { children }
      </MaxWidthLayoutContentDiv>
    </FlexCenterDiv>
  );

  return DesktopBody;
};

export const MaxWidthLayoutMobile = ({ children }: Pick<MaxWidthLayoutProps, 'children'>) => {
  const MobileBody = (
    <FlexCenterDiv>
      <MobileMaxWidthLayoutContentDiv>
        { children }
      </MobileMaxWidthLayoutContentDiv>
    </FlexCenterDiv>
  );

  return MobileBody;
};

export default MaxWidthLayout;
